import React from "react";
import SelectField from "venuescanner-js/react/components/SelectField/SelectField";
import radiusValues from "../radiusValues";
import { formikMuiSelectField } from "venuescanner-js/react/components/MuiFields/muiSelectField";

const addPlusOnRadius = radiusValues.map(({ label, value }) => {
  label = parseInt(value) === 0 ? label : "+" + label;

  return {
    label: label,
    value: value,
  };
});

const RadiusInMiles = React.forwardRef((props, ref) => (
  <SelectField
    options={addPlusOnRadius}
    id="radiusInMiles"
    ref={ref}
    {...props}
  />
));

export default formikMuiSelectField(RadiusInMiles);
